<template>
    <div style="padding: 15px;height: 100vh">
        <div v-if="render_type != 'edit_user_admin'" class="app-content">
            <a-spin :spinning="loading">
                <a-card :title="title">
                    <template #extra>
                        <a-space>
                            <router-link :to="`/app/withdrawAdmin/history`">
                                <a-button v-if="button_title" style="display: flex;"
                                    type="primary" size="large">
                                    {{ button_title }}
                                </a-button>
                            </router-link>
                        </a-space>
                    </template>

                    <a-row>
                        <a-space>
                            <a-input-search style="width: 300px;" v-model:value="search_input" :placeholder="`ค้นหาชื่อผู้ส่งคำขอ`" enter-button="Search"/>
                            <a-range-picker v-model:value="timeStart" />
                        </a-space>
                        <a-button @click="clear_search" type="dashed" style="margin-left: 1rem">CLEAR</a-button>
                    </a-row>

                    <br>
                    <a-row>
                        <a-table :columns="filteredColumns" :data-source="filtered_list(leave_progress1)" bordered size="small" :scroll="{ x: 'calc(100px + 50%)', y: '100%' }">
                            <template #bodyCell="{ column, record }">
                                <template v-if="column.key === 'fullname'">
                                    <div> {{ record.fullname }} </div>
                                </template>
                                <template v-if="column.key === 'withdraw_user_timestamp'">
                                    <div> {{ render_date(record.withdraw_user_timestamp) }} </div>
                                </template>
                                <template v-if="column.key === 'time_start'">
                                    <div> {{ render_date(record.time_start) }} </div>
                                </template>
                                <template v-if="column.key === 'claim_type_id'">
                                    <div> {{ getLeavePatternTypeName(record.claim_type_id) }} </div>
                                </template>
                                <template v-if="column.key === 'withdraw_user_amount'">
                                    <div> {{Number(record.withdraw_user_amount).toLocaleString() }} </div>
                                </template>
                                <template v-if="column.key === 'approve_status'">
                                    <a-select style="width: 120px;" placeholder="การอนุมัติ" v-model:value="record.approve_status"
                                        @change="(value) => handleChangeApproveStatus(record.id, value)">
                                        <a-select-option value=1>อนุมัติ</a-select-option>
                                        <a-select-option value=2>ไม่อนุมัติ</a-select-option>
                                    </a-select>
                                </template>
                                <template v-if="column.key === 'approver'">
                                    <div v-if="businessTypeId == 4">{{ userNameData }}</div>
                                    <a-select v-else style="width: 180px;" placeholder="ชื่อผู้อนุมัติ" v-model:value="record.approver"
                                        @change="(value) => handleChangeApprover(record.id, value)">
                                        <a-select-option
                                            v-for="({ fullname }, i) in administrative"
                                            :key="i"
                                            :value="fullname"
                                            >
                                            {{ fullname }}
                                        </a-select-option>
                                    </a-select>
                                </template>
                                <template v-if="column.key === 'id'">
                                    <div>
                                        <a @click="handleApprove(record.id)"><span class="material-symbols-outlined">
                                                Send
                                            </span>
                                        </a>
                                        <a-divider type="vertical"></a-divider>
                                        <a><span style="font-size: 14px" class="material-symbols-outlined" @click="showLeaveDetails(record)">Visibility</span></a>
                                        <a-divider type="vertical"></a-divider>
                                        <a @click="remove_leave_user(record.id)">
                                            <span class="material-symbols-outlined">
                                                delete
                                            </span>
                                        </a>
                                    </div>
                                </template>
                            </template>
                        </a-table>
                    </a-row>
                    <a-modal v-model:visible="showModalLeaveUserData" @ok="showModalLeaveUserData=false" >
                        <div style="display: flex; flex-direction: column ;justify-items:start;align-items: start">
                            <a-form-item label="ชื่อ-นามสกุล ผู้ส่งคำขอ" name="leave_user_no" style="width: 98%; margin-top: 5%;">
                                <a-input :value="selectedLeave.fullname" placeholder="ชื่อ-นามสกุล ผู้ส่งคำขอ" disabled></a-input>
                            </a-form-item>
                            <a-form-item label="เลขกำกับใบเบิก" name="leave_user_no" style="width: 98%;">
                                <a-input :value="selectedLeave.withdraw_user_no" placeholder="เลขกำกับใบเบิก" disabled></a-input>
                            </a-form-item>
                            <a-form-item label="วันที่แจ้งเบิก" name="leave_user_no" style="width: 98%;">
                                <a-input :value="render_date(selectedLeave.withdraw_user_timestamp)" placeholder="วันที่แจ้งเบิก" disabled></a-input>
                            </a-form-item>
                            <a-form-item label="วันที่ขอเบิก" name="leave_user_no" style="width: 98%;">
                                <a-input :value="render_date(selectedLeave.time_start)" placeholder="วันที่ขอเบิก" disabled></a-input>
                            </a-form-item>
                            <a-form-item label="ประเภทการเบิก" name="leave_user_no" style="width: 98%;">
                                <a-input :value="getLeavePatternTypeName(selectedLeave.claim_type_id)" placeholder="ประเภทการเบิก" disabled></a-input>
                            </a-form-item>
                            <a-form-item label="จำนวนวันขอเบิก" name="leave_user_no" style="width: 98%;">
                                <a-input :value="selectedLeave.withdraw_user_amount" placeholder="จำนวนวันขอเบิก" disabled></a-input>
                            </a-form-item>
                            <a-form-item label="ผลอนุมัติ" name="leave_user_no" style="width: 98%;">
                                <!-- <a-input :value="getApproveStatusName(selectedLeave.approve_status)" placeholder="การอนุมัติ"></a-input> -->
                                <a-select style="width: 100%;" placeholder="ผลอนุมัติ" v-model:value="selectedLeave.approve_status"
                                        @change="(value) => handleChangeApproveStatus(selectedLeave.id, value)">
                                        <a-select-option value=1>อนุมัติ</a-select-option>
                                        <a-select-option value=2>ไม่อนุมัติ</a-select-option>
                                    </a-select>
                            </a-form-item>
                            <a-form-item label="เหตุผลการขอเบิก" name="leave_user_no" style="width: 98%;">
                                <a-input :value="selectedLeave.withdraw_user_remark" placeholder="เหตุผลการขอเบิก" disabled></a-input>
                            </a-form-item>
                            <div>
                            <p>ใบรูปหลักฐานการโอน:</p>
                            <div v-if="selectedLeave.photo_1 != null && selectedLeave.photo_1 != ''" class="image-container" style="margin-top: -5px; margin-bottom: 15px;">
                                <img :src="selectedLeave.photo_1" class="uploaded-image-table" alt="uploaded image" />
                                <div class="icon-container">
                                    <span class="material-symbols-outlined preview-icon" @click="showPreview($event, selectedLeave.photo_1)">
                                        visibility
                                    </span>
                                    <span class="material-symbols-outlined download-icon"
                                        @click="getBase64Image($event, selectedLeave.photo_1)">
                                        download
                                    </span>
                                    <span class="material-symbols-outlined download-icon"
                                        @click="remove_uploaded_file">
                                        Delete
                                    </span>
                                </div>
                            </div>
                            <a-upload 
                                v-else
                                v-model:file-list="fileList"
                                list-type="picture-card"
                                class="avatar-uploader"
                                name="photo_1"
                                :action="upload_files"
                                accept="image/*"
                                method="GET"
                                :show-upload-list="false"
                                @remove="remove_uploaded_file">
                                <div style="height: 104px; width: 173px; padding: 2rem">
                                    <span style="font-size: 40px" class="material-symbols-outlined">upload_file</span>
                                    <div style="margin-top: 8px">คลิกเพื่ออัพโหลดรูปภาพ</div>
                                </div>
                            </a-upload>
                            </div>
                            <a-form-item label="หมายเหตุ" name="withdraw_admin_remark" style="width: 98%;">
                                <a-textarea v-model:value="selectedLeave.withdraw_admin_remark" placeholder="หมายเหตุ" :rows="3"></a-textarea>
                            </a-form-item>
                            <a-form-item label="ชื่อผู้อนุมัติการเบิก" name="approver" style="width: 98%; margin-top: 6%;">
                                <a-select style="width: 100%;" placeholder="ชื่อผู้อนุมัติ" v-model:value="selectedLeave.approver"
                                    @change="(value) => handleChangeApprover(selectedLeave.id, value)">
                                    <a-select-option
                                        v-for="({ fullname }, i) in administrative"
                                        :key="i"
                                        :value="fullname"
                                        >
                                        {{ fullname }}
                                    </a-select-option>
                                </a-select>
                            </a-form-item>
                        </div>
                        <template #footer>
                            <a-button type="primary" @click="submitWithdrawAdmin()">
                                ยืนยัน
                            </a-button>
                            <a-button @click="showModalLeaveUserData=false">
                                ปิด
                            </a-button>
                        </template> 
                    </a-modal> 
                    <a-modal v-model:visible="previewVisible" :footer="null" :mask="false" @cancel="previewVisible = false"
                        class="custom-modal" style="background-color: none !important">
                        <img :src="previewImage" alt="Preview" style="width: 100%;" />
                    </a-modal>
                </a-card>
            </a-spin>
        </div>
    </div>
</template>

<script>
import Utility from '../../utility'
import Swal from 'sweetalert2'
import SystemService from '../../api/SystemService'
import AdminService from '../../api/AdminService';
import LeaveUserService from '../../api/LeaveUserService';
import dayjs from 'dayjs'
import CompanyService from '../../api/CompanyService'
import UserService from '../../api/UserService';
import LeaveService from '../../api/LeaveService';
import AccountingService from '../../api/AccountingService';
import LeaveAdminService from '../../api/LeaveAdminService';
import AdministrativeService from '../../api/AdministrativeService';
import WithdrawAdminService from '../../api/WithdrawAdminService';
import WithdrawUserService from '../../api/WithdrawUserService';
import HumanResourceService from '../../api/HumanResourceService ';

export default {
    name: 'LeaveAdmin',
    data() {
        return {
            previewImage: "",
            previewVisible: false,
            businessTypeId:null,
            leave_user: [],
            leave_progress1: [],
            selectedLeave: {},
            showModalLeaveUserData: false,
            timeStart: null,
            timeEnd: null,
            leave_types: [],
            loading: false,
            search_business_type: null,
            business: false,
            userNameData: "",
            leave_pattern_list:[
                {id: 1, name:'เงินสด'},
                {id: 2, name:'เงินโอน'},
            ],
            leave_quota_data: [], // ดึงข้อมูลโควตาจาก API
            img_placeholder: require('@/assets/images/place-holder/placeholder.jpg'),
            show_table_list: [],
            leave_types: [],
            operations: [],
            accounting: [],
            administrative: [],
            fileList: [],
            title: 'จัดการคำขอเบิก',
            button_title: 'ประวัติการแจ้งเบิก',
            input: 'Username / ชื่อบริษัท',
            search_input: null,
            columns: [
                {
                    title: 'ชื่อ-นามสกุล ผู้ส่งคำขอ',
                    dataIndex: 'fullname',
                    key: 'fullname',
                    width: 200,
                    align: 'center',
                },
                {
                    title: 'วันที่แจ้งเบิก',
                    dataIndex: 'withdraw_user_timestamp',
                    key: 'withdraw_user_timestamp',
                    width: 120,
                    align: 'center',
                }, 
                {
                    title: 'วันที่ขอเบิก',
                    dataIndex: 'time_start',
                    key: 'time_start',
                    width: 180,
                    align: 'center',
                }, 
                {
                    title: 'เลขกำกับใบเบิก',
                    dataIndex: 'withdraw_user_no',
                    key: 'withdraw_user_no',
                    width: 150,
                    align: 'center',
                }, 
                {
                    title: 'ปรเภทการเบิกเงิน',
                    dataIndex: 'claim_type_id',
                    key: 'claim_type_id',
                    width: 120,
                    align: 'center',
                },
                {
                    title: 'จำนวนขอเบิก',
                    dataIndex: 'withdraw_user_amount',
                    key: 'withdraw_user_amount',
                    width: 90,
                    align: 'center',
                },
                {
                    title: 'การอนุมัติ',
                    dataIndex: 'approve_status',
                    key: 'approve_status',
                    width: 150,
                    align: 'center',
                }, 
                {
                    title: 'ชื่อผู้อนุมัติการเบิก',
                    dataIndex: 'approver',
                    key: 'approver',
                    width: 210,
                    align: 'center',
                }, 
                {
                    title: 'ตัวเลือก',
                    dataIndex: 'id',
                    key: 'id',
                    width: 130,
                    align: 'center',
                    fixed: 'right'
                }
            ],
        }
    },
    watch: {

    },
    methods: {
        async getBase64Image(e, file) {
            e.stopPropagation();
            e.preventDefault();

            if (typeof file === 'string') {
                const result = await this.getBase64ImageFromURL(file);
                let a = document.createElement('a');
                a.href = result;
                a.download = 'image.png';
                a.click();
            } else if (file.url) {
                const result = await this.getBase64ImageFromURL(file.url);

                // download
                let a = document.createElement('a');
                a.href = result;
                a.download = 'image.png';
                a.click();
            } else {
                const reader = new FileReader();
                reader.readAsDataURL(file.originFileObj);
                reader.onload = () => {
                    const base64String = reader.result;
                    let a = document.createElement('a');
                    a.href = base64String;
                    a.download = 'image.png';
                    a.click();
                };
            }
        },
        showPreview(e, fileUrl) {
            e.stopPropagation();
            this.previewImage = fileUrl;
            this.previewVisible = true;
        },
        async upload_files(e) {
            try {
                const base64 = await this.getBase64(e);
                this.selectedLeave.photo_1 = base64;
                const response = await fetch('https://mocki.io/v1/283f0879-26ca-4020-9a50-e90025fd52c6');
                if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
                return response.url;
            } catch (error) {
                console.error('Error uploading files:', error);
            }
        },
         getBase64(file) {
            return new Promise((resolve, reject) =>{
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => resolve(reader.result)
                reader.onerror = error => reject(error)
            })
        },
        async remove_uploaded_file() {
            this.fileList = [];
            this.selectedLeave.photo_1 = null
            this.onRefresh();
        },
        async getBase64ImageFromURL(url) {
            const res = await fetch(url, {
                method: 'GET',
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json'
                },
                redirect: 'follow',
                referrerPolicy: 'no-referrer'
            });
            const blob = await res.blob();
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onloadend = () => {
                    resolve(reader.result);
                };
                reader.onerror = reject;
                reader.readAsDataURL(blob);
            });
        },
        render_date(datetime) {
            return dayjs(datetime).format('YYYY/MM/DD')
        },
        getApproveStatusName(status) {
            if (status == 1) {
                return 'อนุมัติ';
            } else if (status == 2) {
                return 'ไม่อนุมัติ';
            } else {
                return '';
            }
        },
        remove_leave_user(id){
            Swal.fire({
                title: 'คุณต้องการลบใช่หรือไม่??',
                text: `คุณจะไม่สามารถกู้คืนได้`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'ใช่',
                cancelButtonText: 'ยกเลิก'
                }).then(async (result) => {
                if (result.isConfirmed) {
                    await SystemService.delete_all('WithdrawAdmin', id)
                    this.onRefresh()
                }
            })
        },
        showLeaveDetails(record) {
            this.selectedLeave = record;
            this.showModalLeaveUserData = true;
        },
        onRefresh() {
             this.init_leave_admins()
        },
        async handleChangeApproveStatus(id, value) {
            await SystemService.update_all('WithdrawAdmin', { data: { approve_status: value } }, id);
            this.onRefresh();
        },
        async handleChangeApprover(id, fullname) {
            await SystemService.update_all('WithdrawAdmin', { data: { approver: fullname} }, id);
            // this.onRefresh();
        },
        async handleApprove(id) {
            if(this.businessTypeId == 4){
                await SystemService.update_all('WithdrawAdmin', { data: { approver: this.userNameData} }, id);
                await this.init_leave_admins();
            }
            const leaveAdmin = this.leave_progress1.find(item => item.id === id);
            // const leaveUserByUsernameAndCompany = await WithdrawUserService.getWithdrawUserByCompanyAndId(leaveAdmin.leave_user_id)
            // console.log('5678',leaveAdmin.approve_status)
            if (!leaveAdmin || leaveAdmin.approve_status != 1 && leaveAdmin.approve_status != 2) {
                Swal.fire({
                    title: 'กรุณาอนุมัติการเบิก',
                    icon: 'warning',
                });
                return;
            }
            if (!leaveAdmin || !leaveAdmin.approver) {
                Swal.fire({
                    title: 'กรุณาระบุชื่อผู้อนุมัติการเบิก',
                    icon: 'warning',
                });
                return;
            }
            let leaveUserStatus = '';
            if (leaveAdmin.approve_status == 1) {
                leaveUserStatus = 2;
            } else if (leaveAdmin.approve_status == 2) {
                leaveUserStatus = 3;
            }
            await SystemService.update_all('WithdrawUser', { data: { claim_status_id: leaveUserStatus, withdraw_admin_remark: leaveAdmin.withdraw_admin_remark, photo_1:leaveAdmin.photo_1 } }, leaveAdmin.withdraw_user_id);
            await SystemService.update_all('WithdrawAdmin', { data: { withdraw_progress: 2, approved_date: dayjs().format('YYYY-MM-DD HH:mm:ss') } }, id);
            Swal.fire({
                title: 'ส่งแจ้งเตือนการอนุมัติสำเร็จ',
                icon: 'success',
            });
            this.onRefresh();
        },
        clear_search() {
            this.search_input = null;
            this.timeStart = null;
            this.timeEnd = null;
        },
        render_date(datetime) {
            return dayjs(datetime).format('YYYY/MM/DD')
        },
        filtered_list(array) {
            return array.filter(({ fullname, time_start, time_end }) => {
                let matchesName = true;
                let matchesDateRange = true;
                if (this.search_input) {
                    matchesName = fullname ? fullname.toLowerCase().includes(this.search_input.toLowerCase()) : false;
                }
                // ตรวจสอบช่วงวันที่ (ไม่สนใจเวลา)
                if (this.timeStart) {
                    const filterStart = dayjs(this.timeStart[0]).startOf('day');
                    const filterEnd = dayjs(this.timeStart[1]).endOf('day');
                    const target = dayjs(time_start);
                    matchesDateRange = target.isSameOrAfter(filterStart) && target.isSameOrBefore(filterEnd);
                }
                return matchesName && matchesDateRange;
            });
        },
        async init_leave_pattern(){
            this.leave_pattern_list = await LeaveService.getLeavePatternAll();
        },
        async submitWithdrawAdmin() {
            if (this.fileList) {
                for (var i = 0; i < this.fileList.length; i++) {
                    const target = this.fileList[i];
                    this.selectedLeave['photo_' + (i + 1)] = await this.getBase64(target.originFileObj);
                }
            }
            delete this.selectedLeave.withdraw_user
            await SystemService.update_all('WithdrawAdmin', { data: this.selectedLeave }, this.selectedLeave.id);
            Swal.fire(
                'แก้ไขคำขอเบิกสำเร็จ!',
                'แก้ไขคำขอเบิกสำเร็จแล้ว',
                'success'
            );
            this.onRefresh();
            this.showModalLeaveUserData=false
        },
        async init_leave_admins() {
            try {
                this.leave_progress1 = await WithdrawAdminService.getWithdrawAdminAll()
                this.leave_progress1 = this.leave_progress1.filter(item => item.withdraw_progress != 2)
                    const user = await UserService.get_user_profile();
                    if(user.permission.role == 'administrative'){
                        this.administrative = await AdministrativeService.getAdministrativeByCompany()
                        this.administrative = this.administrative.filter((item)=>item.fullname == user.fullname)
                    }else if(user.permission.role == 'humanresource'){
                        this.administrative = await HumanResourceService.getHumanResourceByCompany()
                        this.administrative = this.administrative.filter((item)=>item.fullname == user.fullname)
                    }
                const userData = JSON.parse(localStorage.getItem('user_profile'));
                this.userNameData = userData?.fullname ? userData?.fullname : userData?.firstname + " " + userData?.lastname;
            } catch (error) {
                console.error('Error initializing leave admins:', error);
            }
        },


        async get_company() {
            try {
                const company = await UserService.get_user_profile();
                const businessType = await CompanyService.getBusinessId(company.company_id);
                this.businessTypeId = businessType.data;
                if (businessType.data === 2 || businessType.data === 3 || businessType.data === 4) {
                    this.business = true;
                }

            } catch (error) {
                console.error("Error in get_company:", error);
            }
        },
        async getBusinessType(){
            const company = await UserService.get_user_profile();
            const businessType = await CompanyService.getBusinessId(company.company_id)
            this.businessTypeId = businessType.data
        },
        getLeaveTypeName(id) {
            const leaveType = this.leave_types.find(type => type.id === id);
            return leaveType ? leaveType.name : '';
        },
        getLeavePatternTypeName(id) {
            const leaveType = this.leave_pattern_list.find(type => type.id === id);
            return leaveType ? leaveType.name : '';
        },
    },
    computed: {
        render_type() {
            return this.$route.params.type
        },

        filteredColumns() {
            if (Array.isArray(this.columns)) {
                return this.columns.filter(column => {
                    if(this.businessTypeId != 3 && this.businesssTypeId != 2){
                        return column.key !== 'leave_pattern_id'
                    }
                    return column.key !== 'leave_quota' || this.business;
                });
            }
            return [];
        
         },
         leave_quota_limits() {
            return this.businessTypeId === 4
                ? {
                    1: 7,  // ลากิจ: 7 ครั้ง/ปี
                    2: 12,  // ลาพักร้อน: 12 ครั้ง/ปี
                    4: 30, // ลาป่วย: 30 ครั้ง/ปี
                    6: null, // ลาชาปนกิจ: ไม่มีเงื่อนไข
                }
                : {
                    1: 3,  // ลากิจ: 3 ครั้ง/ปี
                    2: 8,  // ลาพักร้อน: 8 ครั้ง/ปี
                    7: 4,  // ลาฝึกอบรม: 4 ครั้ง/ปี
                    4: 30, // ลาป่วย: 30 ครั้ง/ปี
                    5: null, // ลาแบบไม่รับค่าจ้าง: ไม่มีเงื่อนไข
                    6: null, // ลาชาปนกิจ: ไม่มีเงื่อนไข
                };
        },
    },
    async mounted() {
        await this.getBusinessType();
        // await this.init_leave_pattern();
        this.init_leave_admins().then(() => {
        this.get_company().then();

    });
    }
}
</script>

<style>
.preview-icon,
.download-icon {
    cursor: pointer;
    font-size: 20px;
    color: black;
}
.image-container {
    position: relative;
    display: inline-block;
}
.uploaded-image-table {
    display: block;
    width: 15rem;
    height: auto;
}
.icon-container {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    flex-direction: column;
    gap: 10px;
    justify-content: center;
    align-items: center;
    background: rgba(255, 255, 255, 0.3);
    border-radius: 4px;
    padding: 5px;
}

.permission-table .ant-table-row-level-0 td:first-child,
.permission-table .ant-table-row-level-0 td:nth-child(2),
.permission-table .ant-table-row-level-0 td:nth-child(3) {
    background-color: #f9f9f9 !important;
}
.permission-table .ant-table-row-expand-icon::before,
.permission-table .ant-table-row-expand-icon::after 
{
    content: '' !important;
    border: none !important;
    background: none; /* ปิด background */
    transform: none !important;
    transition: none !important;
    top: auto !important
}
.permission-table .ant-table-row-expand-icon:not(.ant-table-row-expand-icon-expanded)::before {
    content: '>' !important;
}

.permission-table .ant-table-row-expand-icon.ant-table-row-expand-icon-expanded::before {
    content: 'v' !important;
}
</style>